import { Router } from '@angular/router';
import { ConfirmationService } from './confirmation.service';
import { BsModalService } from 'ngx-bootstrap';
import { ToasterMessageService } from './toaster-message.service';
import { ModalControlService } from './modal-control.service';
import { AttachmentService } from './attachment.service';
import { Globals } from '../objects/Globals';
import { HeaderService } from './header.service';
import { LoginService } from './login.service';
import { MessagePopupService } from './message-popup.service';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { Subject } from 'rxjs';
import { SidePopupService } from './side-popup.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./confirmation.service";
import * as i3 from "ngx-bootstrap/modal";
import * as i4 from "./toaster-message.service";
import * as i5 from "./modal-control.service";
import * as i6 from "./attachment.service";
import * as i7 from "../objects/Globals";
import * as i8 from "./header.service";
import * as i9 from "./login.service";
import * as i10 from "./message-popup.service";
import * as i11 from "./side-popup.service";
var WorkflowReturnService = /** @class */ (function () {
    function WorkflowReturnService(router, confirmationService, modalService, toasterMessageService, modalControlService, attachmentService, globals, headerService, loginService, messagePopupService, sidePopupService) {
        this.router = router;
        this.confirmationService = confirmationService;
        this.modalService = modalService;
        this.toasterMessageService = toasterMessageService;
        this.modalControlService = modalControlService;
        this.attachmentService = attachmentService;
        this.globals = globals;
        this.headerService = headerService;
        this.loginService = loginService;
        this.messagePopupService = messagePopupService;
        this.sidePopupService = sidePopupService;
        this.isLoadingHome = new Subject();
        this.isLoadingHomeChanged = this.isLoadingHome.asObservable();
    }
    WorkflowReturnService.prototype.handleWorkflowReturn = function (command, directOpenPopup, setHomeUrl) {
        var _this = this;
        if (directOpenPopup === void 0) { directOpenPopup = true; }
        if (setHomeUrl === void 0) { setHomeUrl = false; }
        /**
         * If directOpenPopup is set to true, it will open the detail popup straight away in this service.
         * If directOpenPopup set to false means the popup handling will be done in the component instead of here, ex : open by emitting, input output of EPIC
         * Any component that wants to subscribe to this method need to add the handling for loading of goHome method, case 10 in their component
         */
        switch (command.ReturnType) {
            case 0:// navigate
                if (command.Arguments) {
                    var path = [];
                    command.Arguments.forEach(function (element) {
                        path.push(element);
                    });
                    if (setHomeUrl) {
                        this.globals.Session.HomeUrl = path;
                    }
                    this.router.navigate(path);
                }
                this.hidesAllModals();
                break;
            case 1://message
                this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
                break;
            case 2://reload, does nothing, depends on refreshtype
                break;
            case 3://open detail
                if (directOpenPopup) {
                    this.openPopup(command.Arguments[0], "");
                }
                if (command.Arguments[1] && command.Arguments[2]) {
                    this.toasterMessageService.popToast(command.Arguments[1], command.Arguments[2], command.SubType);
                }
                break;
            case 4://message
                var list = ["parent", "all"];
                if (list.filter(function (x) { return x == command.RefreshType; }).length == 0) {
                    // this.hidePopup.emit(true);
                    if (this.modalService.getModalsCount() > 0) {
                        this.modalService.hide(this.modalService.getModalsCount());
                        if (this.modalService.getModalsCount() == 0) {
                            document.body.classList.remove("modal-open");
                        }
                    }
                }
                this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
                if (command.Arguments[2] && directOpenPopup) {
                    this.openPopup(command.Arguments[2], "");
                }
                break;
            case 5://summary popup
                this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "summary", "modal-summary", command.Arguments[2]);
                break;
            case 6:// comparison
                this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "compare");
                break;
            case 7://download file
                this.attachmentService.downloadFile(command.Arguments[0]).subscribe(function (data) {
                    _this.downloadFile(data, command.Arguments[1]);
                });
                break;
            case 8://messagenavigate
                if (this.globals.Session) {
                    if (command.Arguments) {
                        this.handleNavigateAndMessage(command, true, setHomeUrl);
                    }
                }
                else {
                    this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe(function (respond) {
                        if (respond.answer == "OK") {
                            _this.handleNavigateAndMessage(command, false, setHomeUrl);
                        }
                    });
                }
                break;
            case 9://chart
                break;
            case 10:// go home and navigate
                this.isLoadingHome.next(true);
                this.loginService.goHome().subscribe(function (result) {
                    _this.isLoadingHome.next(false);
                    _this.globals.Session.HomeUrl = JSON.parse(result);
                    _this.router.navigate(_this.globals.Session.HomeUrl);
                });
                break;
            case 11:// open form
                this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "form", "modal-form");
                break;
            case 12:// external navigate
                window.open(command.Arguments[0], "_blank");
                break;
            case 13:
                break;
            case 14:
                break;
            case 15:
                this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1] ? command.Arguments[1] : "Report View", "summary", "modal-summary");
                break;
            case 16:
                if (this.modalService.getModalsCount() > 0) {
                    this.messagePopupService.popMessage("", "Side panel viewing is not supported when clicked from a popup", ["OK"]).subscribe(function (respond) {
                        if (respond.answer == "OK") {
                            console.log("ok");
                        }
                    });
                }
                else {
                    this.sidePopupService.createNewPopup(command.Arguments[0]);
                }
                break;
        }
        // if (command.IsPreview){
        //   this.hidePreview();
        // }
    };
    WorkflowReturnService.prototype.openPopup = function (event, title) {
        // const initialState = {
        //   componentId: event,
        //   title: title
        // };
        var _this = this;
        var config = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-dialog-centered modal-detail',
            initialState: {
                componentId: event,
                title: title
            }
        };
        if (this.modalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
        }
        this.modalService.onHide.subscribe(function (reason) {
            if (_this.modalService.getModalsCount() > 0) {
                document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.add('show');
            }
        });
        this.modalService.show(DetailPopupComponent, config);
    };
    WorkflowReturnService.prototype.downloadFile = function (blob, fileName) {
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);
    };
    WorkflowReturnService.prototype.hidesAllModals = function () {
        if (this.confirmationService.bsModalRef) {
            this.confirmationService.bsModalRef.hide();
        }
        for (var i = 1; i <= this.modalService.getModalsCount(); i++) {
            this.modalService.hide(i);
        }
        document.body.classList.remove('modal-open');
        this.sidePopupService.removePopup();
    };
    WorkflowReturnService.prototype.hidePreview = function () {
        var _this = this;
        if (this.modalService.getModalsCount() > 0) {
            this.modalService.hide(this.modalService.getModalsCount());
            this.modalService.onHide.subscribe(function (reason) {
                if (_this.modalService.getModalsCount() == 0) {
                    document.body.classList.remove("modal-open");
                }
            });
        }
    };
    WorkflowReturnService.prototype.handleNavigateAndMessage = function (command, hasSession, setHomeUrl) {
        if (setHomeUrl === void 0) { setHomeUrl = false; }
        var path = [];
        var newArgs = command.Arguments.splice(2);
        newArgs.forEach(function (element) {
            path.push(element);
        });
        if (setHomeUrl) {
            this.globals.Session.HomeUrl = path;
        }
        if (hasSession) {
            // close all popups
            for (var i = 1; i <= this.modalService.getModalsCount(); i++) {
                this.modalService.hide(i);
            }
            document.body.classList.remove("modal-open");
            this.router.navigate(path);
            this.headerService.setSelectedMenu('clearSelected');
            this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
        }
    };
    WorkflowReturnService.ngInjectableDef = i0.defineInjectable({ factory: function WorkflowReturnService_Factory() { return new WorkflowReturnService(i0.inject(i1.Router), i0.inject(i2.ConfirmationService), i0.inject(i3.BsModalService), i0.inject(i4.ToasterMessageService), i0.inject(i5.ModalControlService), i0.inject(i6.AttachmentService), i0.inject(i7.Globals), i0.inject(i8.HeaderService), i0.inject(i9.LoginService), i0.inject(i10.MessagePopupService), i0.inject(i11.SidePopupService)); }, token: WorkflowReturnService, providedIn: "root" });
    return WorkflowReturnService;
}());
export { WorkflowReturnService };
var WorkflowReturn = /** @class */ (function () {
    function WorkflowReturn() {
    }
    return WorkflowReturn;
}());
export { WorkflowReturn };
var WorkflowReturnType;
(function (WorkflowReturnType) {
    // order matters, please do not make any changes to the order this enum
    WorkflowReturnType[WorkflowReturnType["Navigate"] = 0] = "Navigate";
    WorkflowReturnType[WorkflowReturnType["Message"] = 1] = "Message";
    WorkflowReturnType[WorkflowReturnType["Reload"] = 2] = "Reload";
    WorkflowReturnType[WorkflowReturnType["Detail"] = 3] = "Detail";
    WorkflowReturnType[WorkflowReturnType["ClosePopup"] = 4] = "ClosePopup";
    WorkflowReturnType[WorkflowReturnType["Summary"] = 5] = "Summary";
    WorkflowReturnType[WorkflowReturnType["Compare"] = 6] = "Compare";
    WorkflowReturnType[WorkflowReturnType["File"] = 7] = "File";
    WorkflowReturnType[WorkflowReturnType["MessageNavigate"] = 8] = "MessageNavigate";
    WorkflowReturnType[WorkflowReturnType["Chart"] = 9] = "Chart";
    WorkflowReturnType[WorkflowReturnType["Home"] = 10] = "Home";
    WorkflowReturnType[WorkflowReturnType["Form"] = 11] = "Form";
    WorkflowReturnType[WorkflowReturnType["ExternalNavigate"] = 12] = "ExternalNavigate";
    WorkflowReturnType[WorkflowReturnType["WebContent"] = 13] = "WebContent";
    WorkflowReturnType[WorkflowReturnType["RefreshDetail"] = 14] = "RefreshDetail";
    WorkflowReturnType[WorkflowReturnType["ReportSummary"] = 15] = "ReportSummary";
    WorkflowReturnType[WorkflowReturnType["SideDetail"] = 16] = "SideDetail";
})(WorkflowReturnType || (WorkflowReturnType = {}));
